import React from "react";
import bg from "../../../../assets/img/landing-page/landing-page-bg.png";
import "./style.css";
import { Link } from "react-router-dom";
const LeadbudIdealCustomers = () => {
  return (
    <div
      className="section home-features  feadtures-landing-page"
      style={{
        paddingBottom: "50px",
        backgroundImage: `url('${bg}')`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        <div className="upper aos-item aos-inint aos-animate">
          <h2 style={{ textAlign: "center" }}>
            Reach your ideal <br /> customers with leadbud.io
          </h2>
        </div>
        <div style={{ textAlign: "center" }}>
          <div
            className="landing-page-input"
            style={{ display: "flex", margin: "auto" }}
          >
            <input type="email" placeholder="Enter your email" />
            <Link to={"/users/login"} className="btn btn-get-started">
              Start trail
            </Link>
          </div>
        </div>
        <div className="landing-page-item">
          <div
            className="items"
            style={{
              marginTop: "100px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="item">
              <i class="fa-solid fa-circle-check"></i>
              <p>Free contact shows a month</p>
            </div>
            <div className="item">
              <i class="fa-solid fa-circle-check"></i>
              <p>Instant access</p>
            </div>
            <div className="item">
              <i class="fa-solid fa-circle-check"></i>
              <p>280,000 companies love us</p>
            </div>
            <div className="item">
              <i class="fa-solid fa-circle-check"></i>
              <p>Cancel anytimeaccess</p>
            </div>
            <div className="item">
              <i class="fa-solid fa-circle-check"></i>
              <p>Monthly & yearly contracts</p>
            </div>
            <div className="item">
              <i class="fa-solid fa-circle-check"></i>
              <p>Instant GDPR compliant & CCPA compliant</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadbudIdealCustomers;
